import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Checkbox from '@mui/material/Checkbox';

import Button from '@ts-core/components/Button';

const SubjectItemsSelector = (props) => {
  const {
    className,
    title,
    sections,
    loading,
    submitting,
    onToggleItem,
    isItemSelected,
    noItemsSelected,
    onConfirmSelection,
    confirmButtonTitle,
  } = props;

  const handleToggleItem = useCallback(
    (item) => () => {
      onToggleItem(item);
    },
    [onToggleItem]
  );

  return (
    <Box className={className}>
      {sections.length > 0 && (
        <>
          {title && <Typography variant="subtitle2">{title}</Typography>}

          <Box mt={2} boxShadow={1} p={2}>
            {sections.map((section, index) => {
              return (
                <List
                  subheader={<ListSubheader>{section.title}</ListSubheader>}
                  key={index}
                >
                  {section.items.map((item) => (
                    <ListItem
                      key={item._id}
                      divider
                      button
                      onClick={handleToggleItem(item)}
                    >
                      <ListItemText primary={item.name} />
                      <ListItemSecondaryAction>
                        <Checkbox
                          checked={isItemSelected(item)}
                          disabled={loading}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              );
            })}
          </Box>
        </>
      )}

      <Box display="flex" flexDirection="row" justifyContent="flex-end" mt={2}>
        <Button
          variant="contained"
          color="primary"
          loading={submitting}
          disabled={noItemsSelected || loading || submitting}
          onClick={onConfirmSelection}
        >
          {confirmButtonTitle}
        </Button>
      </Box>
    </Box>
  );
};

SubjectItemsSelector.propTypes = {
  className: PropTypes.string,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.array,
    })
  ),
  loading: PropTypes.bool,
  submitting: PropTypes.bool,
  title: PropTypes.node,
  noItemsSelected: PropTypes.bool,
  confirmButtonTitle: PropTypes.node,

  onToggleItem: PropTypes.func.isRequired,
  isItemSelected: PropTypes.func.isRequired,
  onConfirmSelection: PropTypes.func.isRequired,
};

SubjectItemsSelector.defaultProps = {
  className: undefined,
  title: undefined,
  noItemsSelected: false,
  sections: [],
  loading: false,
  submitting: false,
  confirmButtonTitle: undefined,
};

export default SubjectItemsSelector;
